import getConfirmationWithVariables from '../services/slate/getConfirmationWithVariables';
import { loadSlateContent } from '../services/slate/load-slate-content';

export function parseConfirmationMessage(message, { charge, seller, checkout }) {
  try {
    const parsedValue = typeof message === 'string' ? JSON.parse(message) : message;
    const content = loadSlateContent(parsedValue);

    return {
      html: getConfirmationWithVariables(content, charge, seller, checkout),
    };
  } catch (e) {
    return {
      text: message,
    };
  }
}
